import { Alert, Col, Container, Row } from "react-bootstrap";
import { TABLE_TYPES } from "../../components/FastTable/FastTable";
import { Link, useParams } from "react-router-dom";
import {
  faArrowLeft,
  faArrowRight,
  faList,
} from "@fortawesome/free-solid-svg-icons";

import FastForm from "../../components/FastForm/FastForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useEvents from "../../hooks/useEvents";

import { useMemo } from "react";
import { usePage } from "../../hooks/usePage";
import useReports from "../../hooks/useReports";
import useUsers from "../../hooks/useUsers";
import UserTransactions from "../../components/user/UserTransactions";
import UserNFCData from "../../components/user/UserNFCData";

export default function EditUser() {
  usePage({ title: "Editar usuario" });
  const params = useParams();
  const { data: events } = useEvents();
  const userid = !isNaN(params?.userid) ? parseInt(params.userid) : null;

  const { data: users, editUserMutation } = useUsers();

  // eslint-disable-next-line no-unused-vars
  const [thisUserIndex, nextUserIndex, prevUserIndex] = useMemo(() => {
    if (!users) return [0, 0, 0];
    const thisUserIndex = users.findIndex(
      (product) => parseInt(product.userid) === parseInt(userid)
    );
    return [
      thisUserIndex,
      thisUserIndex < users.length - 1 ? thisUserIndex + 1 : 0,
      thisUserIndex > 0 ? thisUserIndex - 1 : users.length - 1,
    ];
  }, [users, userid]);

  const user = useMemo(() => {
    return users?.find((u) => parseInt(u.userid) === userid);
  }, [users, userid]);

  const reports = useReports({
    eventid: params.eventid,
    limit: 10000000,
    offset: 0,
    start: 1,
    tag: user?.tag
  });

  const txs = useMemo(() => {
    if (reports.parsedData && user?.tag) {
      return reports.parsedData.filter((tx) => tx.tag === user.tag);
    }
    return [];
  }, [reports.parsedData, user?.tag]);

  return (
    <Container fluid className="pt-4">
      <Row>
        <Col>
          {user?.block === "1" && (
            <Alert variant="danger" className="text-center">Este usuario está bloqueado</Alert>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <h1>
            Usuario{" "}
            {user?.name ? user.name : user?.tag ? user.tag : params?.userid}
          </h1>
        </Col>
        <Col
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          {users?.length > 1 && (
            <>
              <Link
                className="nav-link text-primary"
                to={`/${params?.eventid}/users/${users[prevUserIndex]?.userid}`}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </Link>
              <Link
                className="nav-link text-primary"
                to={`/${params?.eventid}/users`}
              >
                <FontAwesomeIcon icon={faList} />
              </Link>
              <Link
                className="nav-link text-primary"
                to={`/${params?.eventid}/users/${users[nextUserIndex]?.userid}`}
              >
                <FontAwesomeIcon icon={faArrowRight} />
              </Link>
            </>
          )}
        </Col>
      </Row>
      {!user ? (
        <Alert variant="danger">
          No existe el usuario que buscas{" "}
          <Link to={`/${params.eventid}/users`}>Volver</Link>
        </Alert>
      ) : (
        <Row key={user?.userid}>
          <Col>
            <h2>Editar datos de usuario</h2>
            <FastForm
              mutation={editUserMutation}
              sendText="Guardar cambios"
              postParseData={(values) => {
                const { repair, block, ...data } = values;
                if (repair) {
                  data.repair = "1";
                } else {
                  data.repair = "0";
                }
                if (block) {
                  data.block = "1";
                } else {
                  data.block = "0";
                }
                return data;
              }}
              fields={[
                {
                  name: "userid",
                  type: "hidden",
                  defaultValue: parseInt(userid),
                },
                {
                  name: "name",
                  defaultValue: user?.name,
                  label: "Nombre",
                  placeholder: "Nombre",
                  type: "text",
                },
                {
                  name: "email",
                  defaultValue: user?.email,
                  label: "Email",
                  placeholder: "Email",
                  type: "email",
                  attributes: {
                    autofill: "not-my-email",
                    id: "not-my-email",
                  },
                },
                {
                  name: "tag",
                  defaultValue: user?.tag,
                  label: "Tag",
                  placeholder: "Tag",
                  type: "text",
                },
                {
                  name: "shortag",
                  defaultValue: user?.shortag,
                  label: "Short Tag",
                  placeholder: "Short Tag",
                  type: "text",
                },
                {
                  name: "eventid",
                  defaultValue: user?.eventid,
                  label: "Evento",
                  type: TABLE_TYPES.options,
                  options: [
                    { label: "Elige un evento", value: 0 },
                    ...events.map((e) => ({
                      label: e.name,
                      value: e.eventid,
                    })),
                  ],
                },
                {
                  name: "repair",
                  defaultValue: user?.repair === "1",
                  label: "Reparar",
                  type: "checkbox",
                  style: { width: "auto", flex: "1" },
                },
                {
                  name: "block",
                  defaultValue: user?.block === "1",
                  label: "Bloquear",
                  type: "checkbox",
                  style: { width: "auto", flex: "1" },
                },
              ]}
            />
          </Col>
          <Col lg={8}>
            <UserNFCData basicUser={user} txs={txs} />
            <hr />
            <UserTransactions txs={txs} eventid={params.eventid} />
          </Col>
        </Row>
      )}
    </Container>
  );
}
